import { COLOR_WHITE } from 'constants/colors';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};
`;
